export const FIRST_AD_PROMPT = 'Create 1 ad introducing my product, using my saved brand and product details. Use only verified benefits and offers.';
